/**
 * Modal controls.
 */
export default function modalSection() {

}



// WEBPACK FOOTER //
// ./source/scripts/sections/modal.js